class statisticsPurchaseRankListCtrl {
    constructor($scope, httpRequest, $state, $filter, treeSelectService) {
        // 字典数据
        $scope.dictData = {}
        const typecodeArr = ['ivat_vat_inv_type']
        httpRequest.get_dictByTypeArr(typecodeArr).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
        })
        $scope.reset = function () {
            $scope.param = {
                pageNum: 1,
                pageSize: 10,
                param: {
                    invoiceType: '',
                    invoiceDateEnd: $filter('date')(new Date(), 'yyyy-MM'),
                    invoiceDateBegin: $filter('date')(new Date(), 'yyyy-MM'),
                    rank: '10',
                    saleName: '',
                    custName: '',
                    accessToken: localStorage.id_token,
                    custCreditCode: '',
                },
            }
            $scope.querySaleConfig.defaultSelect = []
        }

        $scope.getDetailParam = {}
        let orgIdArr = []
        $scope.rankList = [ 
            {
                name: '前十',
                value: 10,
            },
            {
                name: '前二十',
                value: 20,
            },
            {
                name: '前五十',
                value: 50,
            },
        ]
        $scope.datePickerConfig = {
            format: 'yyyy-mm',
            minView: 3,
            startView: 3,
        }

        $scope.saleList = [] // 购方
        // 更新时间
        $scope.total = {
            companyNum: 0,
            totalTurnOver: 0,
        }

        // 下拉购方
        $scope.querySaleConfig = {
            queryName: 'saleName',
            queryKey: 'saleId',
            queryType: 'Flater',
            parentIdName: 'parentSaleId',
            multiple: true,
            parentId: 0,
            defaultSelect: [],
        }
        $scope.reset()
        httpRequest.get_getUserOrgList().then(
            (res) => {
                orgIdArr = res.data.value.map((item) => item.orgId)
                getSaleInfo()
            },
        )
        function getSaleInfo() {
            httpRequest.post_getSaleInfoListByOrgIds(orgIdArr).then(
                (res) => {
                    $scope.saleList = treeSelectService(res.data, 'saleId', 'saleName')
                    queryInfo()
                },
            )
        }  
        function queryInfo() {
            $scope.param = sessionStorage.purchaseParam ? JSON.parse(sessionStorage.purchaseParam) : $scope.param
            $scope.getDetailParam = JSON.parse(JSON.stringify($scope.param.param))
            httpRequest.post_selectTotalPurchase($scope.param.param).then((res) => {
                if (res.data.success) {
                    $scope.total.companyNum = res.data.value.companyNum || 0
                    $scope.total.totalTurnOver = res.data.value.totalTurnOver || 0
                }
            })
            httpRequest.post_selectPurchaseRanking($scope.param).then((res) => {
                $scope.listData = res.data.value.list
                $scope.totalItems = res.data.value.total
                $scope.param.pageNum = res.data.value.pageNum
            })
        }
        // 分页
        $scope.pageChanged = function () { // 点击页码发起查询
            sessionStorage.setItem('purchaseParam', JSON.stringify(
                { 
                    pageNum: $scope.param.pageNum,
                    pageSize: $scope.param.pageSize,
                    param: sessionStorage.purchaseParam ? JSON.parse(sessionStorage.purchaseParam).param : { 
                        invoiceType: '',
                        invoiceDateEnd: $filter('date')(new Date(), 'yyyy-MM'),
                        invoiceDateBegin: $filter('date')(new Date(), 'yyyy-MM'),
                        rank: '10',
                        saleName: '',
                        custName: '',
                        accessToken: localStorage.id_token,
                        custCreditCode: '', 
                    },
                },
            ))
            queryInfo()
        }
        // 购方变化
        $scope.saleSelectChange = function (v) {
            const saleSelectArr = v
            const saleSelectL = saleSelectArr.length
            if (saleSelectL > 0) {
                $scope.param.param.custName = saleSelectArr.map((item) => item.saleName).join()
                $scope.param.param.custCreditCode = saleSelectArr.map((item) => item.saleCreditCode).join()
            } else {
                $scope.param.param.custName = ''
                $scope.param.param.custCreditCode = ''
            }
        }

        // 导出
        $scope.exportInvoic = function () {
            httpRequest.get_exportPurchaseRanking($scope.param.param)
        }

        // 详情
        $scope.toDetailPage = function (item) {
            const temp = JSON.parse(JSON.stringify(item))
            temp.invoiceDateBegin = $scope.getDetailParam.invoiceDateBegin
            temp.invoiceDateEnd = $scope.getDetailParam.invoiceDateEnd
            temp.invoiceType = $scope.getDetailParam.invoiceType
            temp.custName = $scope.getDetailParam.custName
            temp.custCreditCode = $scope.getDetailParam.custCreditCode
            $state.go(
                'statistics.inputStatistics.statisticsPurchaseRank.detail',
                {
                    params: JSON.stringify(temp),
                },
            )
        }
        // 搜索
        $scope.searchlist = function () { // 点击搜索发起查询
            sessionStorage.setItem('purchaseParam', JSON.stringify($scope.param))
            queryInfo()
        }
    }
}
statisticsPurchaseRankListCtrl.$inject = ['$scope', 'httpRequest', '$state', '$filter', 'treeSelectService']
export default statisticsPurchaseRankListCtrl



// WEBPACK FOOTER //
// ./src/app/statistics/inputStatistics/statisticsPurchaseRank/statisticsPurchaseRankListCtrl.js